<script lang="ts">
  import { ACHIEVEMENTS, ACHIEVEMENT_IDS, CLASSES } from '@arena/shared';
  import { click } from '../game/Sfx';
  import { app } from '../lib/net.svelte';

  let { onclose }: { onclose: () => void } = $props();

  const earned = $derived(
    ACHIEVEMENT_IDS.filter((id) => id in app.achievements.earned).length,
  );

  function onKey(event: KeyboardEvent) {
    if (event.code !== 'Escape') return;
    event.preventDefault();
    event.stopPropagation();
    click();
    onclose();
  }
</script>

<svelte:window onkeydowncapture={onKey} />

<section class="panel achievements">
  <header>
    <h2>Achievements</h2>
    <span class="muted">{earned} / {ACHIEVEMENT_IDS.length}</span>
    <button class="close" onclick={onclose} aria-label="Close">×</button>
  </header>

  <div class="content">
    <p class="muted small">Only rated matches count.</p>
    <ul>
      {#each ACHIEVEMENT_IDS as id (id)}
        {@const a = ACHIEVEMENTS[id]}
        {@const at = app.achievements.earned[id]}
        {@const value = Math.min(app.achievements.stats[a.stat] ?? 0, a.at)}
        <li class:done={at !== undefined}>
          <div class="line">
            <strong>{a.name}</strong>
            {#if at}
              <span class="muted small"
                >{new Date(at).toLocaleDateString(undefined, {
                  dateStyle: 'medium',
                })}</span
              >
            {/if}
          </div>
          <div class="muted">{a.description}</div>
          {#if a.title}<div class="small">
              Title: <span class="title">{a.title}</span>
            </div>{/if}
          {#if a.trail}<div class="small">
              Weapon trail: <span style:color={CLASSES[a.trail].color}
                >{CLASSES[a.trail].name}</span
              >
            </div>{/if}
          {#if !at}
            <div
              class="bar"
              role="progressbar"
              aria-valuemin="0"
              aria-valuemax={a.at}
              aria-valuenow={Math.round(value)}
            >
              <div style:width="{(value / a.at) * 100}%"></div>
              <span
                >{Math.round(value).toLocaleString()} / {a.at.toLocaleString()}</span
              >
            </div>
          {/if}
        </li>
      {/each}
    </ul>
  </div>
</section>

<style>
  .achievements {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: grid;
    grid-template-rows: auto minmax(0, 1fr);
    width: min(560px, calc(100% - 24px));
    height: min(560px, calc(100% - 48px));
    padding: 0;
    pointer-events: auto;
    background: var(--panel-solid);
    border-color: var(--gold);
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.6);
    font-size: 14px;
  }
  header {
    display: flex;
    gap: 12px;
    align-items: center;
    padding: 10px 18px;
    border-bottom: 1px solid var(--border);
  }
  header h2 {
    margin: 0;
  }
  .close {
    margin-left: auto;
    padding: 0 8px;
    font-size: 18px;
  }
  .content {
    overflow-y: auto;
    padding: 6px 18px 14px;
  }
  ul {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin: 0;
    padding: 0;
    list-style: none;
  }
  li {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 8px 10px;
    border: 1px solid var(--border);
    border-radius: 4px;
    opacity: 0.75;
  }
  li.done {
    opacity: 1;
    border-color: var(--gold);
    background: rgba(230, 192, 106, 0.08);
  }
  .line {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  li.done strong,
  .title {
    color: var(--gold);
  }
  .bar {
    position: relative;
    height: 16px;
    margin-top: 4px;
    background: #111;
    border: 1px solid #000;
    border-radius: 3px;
    overflow: hidden;
  }
  .bar div {
    height: 100%;
    background: linear-gradient(#b98a1c, #6b4f12);
  }
  .bar span {
    position: absolute;
    inset: 0;
    font-size: 11px;
    line-height: 14px;
    text-align: center;
    text-shadow: 0 1px 2px black;
  }
  .muted {
    color: var(--muted);
  }
  .small {
    font-size: 12px;
  }
</style>
